<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Tabs</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="row no-margin CustomPageTabContainer">
                    <!--Tab 1-->
                    <div class="col-6 paddingleft0">
                        <div class="tab tab1">
                            <div class="title">Default Tab</div>
                            <b-tabs>
                                <b-tab title="Tab 1" active>
                                    <br>Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.
                                </b-tab>
                                <b-tab title="Tab 2" >
                                    <br>Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a.
                                </b-tab>
                                <b-tab title="Tab 3" >
                                    <br>Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                    <!--Tab 1-->

                    <!--Tab 2-->
                    <div class="col-6 paddingleft0">
                        <div class="tab tab2">
                            <div class="title">Default Tab</div>
                            <b-tabs>
                                <b-tab title="Tab 1" active>
                                    <br>Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.
                                </b-tab>
                                <b-tab title="Tab 2" >
                                    <br>Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a.
                                </b-tab>
                                <b-tab title="Tab 3" >
                                    <br>Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                    <!--Tab 2-->

                    <div class="height15">&nbsp;</div>

                    <!--Tab 2-->
                    <div class="col-6 paddingleft0">
                        <div class="tab tab4">
                            <div class="title">Custom Vertical Tab</div>
                            <b-card no-body>
                                <b-tabs pills card vertical>
                                    <b-tab title="Dashboard" active>
                                        <h3 class="tabtitle-heading">Best Clean Tab ever</h3>
                                        <h4 class="title-label">you can use it with the small code</h4>

                                        Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica.
                                    </b-tab>
                                    <b-tab title="Profile">
                                        Tab Contents 2
                                    </b-tab>
                                    <b-tab title="Mails">
                                        Tab Contents 3
                                    </b-tab>
                                </b-tabs>
                            </b-card>
                        </div>
                    </div>
                    <!--Tab 2-->

                    <div class="height15">&nbsp;</div>


                    <!--Tab 5-->
                    <div class="col-6 paddingleft0">
                        <div class="tab tab5">
                            <div class="title">Default Tab</div>
                            <b-tabs>
                                <b-tab title="Yesterday" active>
                                    <h3 class="tabtitle-heading">Best Clean Tab ever</h3>
                                    <br>Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a.
                                </b-tab>
                                <b-tab title="Tomorrow" >
                                    <h3>Best Clean Tab ever</h3>
                                    <br>Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a.
                                </b-tab>

                            </b-tabs>
                        </div>
                    </div>
                    <!--Tab 5-->

                </div>


            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>
<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';
    import {bTabs} from 'bootstrap-vue/es/components/tabs/tabs';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,

        },
        data() {
            return {
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/tabs.vue